var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "matrix(1 0 0 -1 0 90)",
    fill: "url(#paint0_linear_2271_199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4296 62.0365L60.5175 59.362C61.0277 58.9199 61.1955 58.2031 60.9359 57.581L52.4386 37.2196C51.1672 34.1756 48.6407 31.9382 45.6034 30.9918L52.8169 23.7899C53.2485 23.3601 53.4056 22.689 53.1567 22.0878C52.9131 21.5 52.3358 21.1226 51.7132 21.1226C50.2807 21.1226 49.1185 20.4884 47.7715 19.7534C46.2673 18.9316 44.5613 18 42.3302 18C40.099 18 38.393 18.9316 36.8887 19.7534C35.5417 20.4884 34.3796 21.1226 32.947 21.1226C32.3252 21.1226 31.7474 21.4988 31.5034 22.0878C31.2545 22.6884 31.4113 23.3597 31.8432 23.7899L39.0568 30.9918C36.0196 31.9382 33.4929 34.1756 32.2215 37.2196L22.5971 60.28C22.2016 61.2329 22 62.2424 22 63.2791C22.0002 67.5835 25.5082 71.0859 29.8195 71.0859H48.1381C48.5917 71.0859 49.0223 70.8892 49.3203 70.5477L52.0326 67.4249C52.5411 66.8378 52.5411 65.9658 52.0326 65.3787L50.9666 64.1528L52.5886 64.0369C53.3645 63.9821 53.9815 63.366 54.0363 62.5915L54.1523 60.9722L55.3802 62.0365C55.9696 62.5458 56.8432 62.5458 57.4296 62.0365ZM43.8941 58.5162V60.1564C43.8941 61.0193 43.1946 61.7177 42.3303 61.7177C41.466 61.7177 40.7664 61.0193 40.7664 60.1564V58.5188C39.81 58.3594 38.9269 57.9196 38.2297 57.2212C37.6205 56.6112 37.6204 55.6218 38.2329 55.0134C38.8453 54.405 39.8349 54.405 40.4442 55.0164C40.7374 55.3106 41.1299 55.4723 41.5485 55.4723H43.1122C43.9751 55.4723 44.676 54.7726 44.676 53.9111C44.676 53.0496 43.9749 52.3496 43.1122 52.3496H41.5485C38.9613 52.3496 36.8569 50.2485 36.8569 47.6655C36.8569 45.35 38.5523 43.4347 40.7664 43.0604V41.4202C40.7664 40.5571 41.4658 39.8589 42.3303 39.8589C43.1948 39.8589 43.8941 40.5573 43.8941 41.4202V43.0578C44.8505 43.2172 45.7336 43.657 46.4308 44.3554C47.0402 44.9654 47.0402 45.9548 46.4278 46.5632C45.8154 47.17 44.8257 47.173 44.2163 46.5601C43.9231 46.2658 43.5306 46.1041 43.1122 46.1041H41.5485C40.6855 46.1041 39.9845 46.8039 39.9845 47.6654C39.9845 48.5269 40.6855 49.2267 41.5485 49.2267H43.1122C45.6994 49.2267 47.8036 51.3278 47.8036 53.9107C47.8036 56.2266 46.1082 58.1418 43.8941 58.5162ZM59.3676 65.7035C58.9812 64.932 58.0388 64.6225 57.2693 65.0051C56.4965 65.391 56.1835 66.3286 56.5698 67.1001L58.1336 70.2229C58.518 70.9884 59.4514 71.3083 60.2319 70.9212C61.0046 70.5354 61.3177 69.5978 60.9313 68.8263L59.3676 65.7035ZM65.788 61.7178H62.6601C61.7958 61.7178 61.0964 62.4162 61.0964 63.2791C61.0964 64.1421 61.7958 64.8404 62.6601 64.8404H65.7878C66.6521 64.8404 67.3516 64.1421 67.3516 63.2791C67.3516 62.4162 66.6523 61.7178 65.788 61.7178Z",
    fill: "url(#paint1_linear_2271_199)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_199",
    x1: 45,
    y1: 90,
    x2: 45,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_199",
    x1: 44.676,
    y1: 71.0859,
    x2: 44.676,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.d55ce5447daf761606554d806ba58535.svg";
export { ForwardRef as ReactComponent };